import Alpine from 'alpinejs'

Alpine.store('Header', {
  isVisible: true,
  scrollPosition: 0,

  setScrollPosition(position: number) {
    this.scrollPosition = position
  },

  show() {
    this.isVisible = true
  },

  hide() {
    this.isVisible = false
  },
})
